import React from "react";
import { Card, CardBody } from "@material-tailwind/react";
import Header from "../Header";

const HearingDetailsSkeleton: React.FC = () => {
  const SkeletonLine = ({
    width = "w-full",
    height = "h-4",
  }: {
    width?: string;
    height?: string;
  }) => (
    <div
      className={`${width} ${height} bg-gray-200 animate-pulse rounded my-2`}
    ></div>
  );

  // Skeleton field with label
  const SkeletonField = () => (
    <div className="mb-4">
      <div className="w-1/3 h-3 bg-gray-200 animate-pulse rounded mb-2"></div>
      <div className="w-full h-5 bg-gray-200 animate-pulse rounded"></div>
    </div>
  );

  return (
    <>
      <Header />
      <div className="flex flex-col space-y-4 p-4 justify-center items-center">
        {/* Hearing Details Card */}
        <Card className="bg-white shadow-lg rounded-lg max-w-2xl w-full">
          <CardBody>
            <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded mb-6 pb-2 border-b"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
              {/* Generate a grid of skeleton fields for details */}
              {Array.from({ length: 12 }).map((_, index) => (
                <SkeletonField key={index} />
              ))}
            </div>
          </CardBody>
        </Card>

        {/* Instructions Card */}
        <Card className="bg-white shadow-lg rounded-lg max-w-2xl w-full">
          <CardBody>
            <div className="w-1/3 h-6 bg-gray-200 animate-pulse rounded mb-4 pb-2 border-b"></div>
            <SkeletonLine />
            <SkeletonLine width="w-11/12" />
            <SkeletonLine width="w-3/4" />
          </CardBody>
        </Card>

        {/* Finalize Hearing Card */}
        <Card className="bg-white shadow-lg rounded-lg max-w-2xl w-full">
          <CardBody>
            <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded mb-4 pb-2 border-b"></div>
            <SkeletonLine width="w-11/12" />
            <SkeletonLine width="w-10/12" />
            <SkeletonLine width="w-3/4" />

            <div className="mt-8 space-y-4">
              <div className="w-full h-64 bg-gray-200 animate-pulse rounded"></div>
              <div className="w-full h-10 bg-gray-200 animate-pulse rounded"></div>
            </div>
          </CardBody>
          <div className="p-4 border-t">
            <div className="w-full h-10 bg-gray-200 animate-pulse rounded"></div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default HearingDetailsSkeleton;
